import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useRouter } from 'next/router';
import { useState } from 'react';
import imgLocale1 from './imgs/imgLocale1';
import imgLocale2 from './imgs/imgLocale2';
import imgLocale3 from './imgs/imgLocale3';
import imgLocale4 from './imgs/imgLocale4';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const theme = ['jp'].includes(locale) ? 'black' : 'white';

    const img1 = imgLocale1[locale] || imgLocale1['us'];
    const img2 = imgLocale2[locale] || imgLocale2['us'];
    const img3 = imgLocale3[locale] || imgLocale3['us'];
    const img4 = imgLocale4[locale] || imgLocale4['us'];
    const listTabH: EfTabItemProps[] = [
        {
            type: 'a1',
            title: t('G_item1_tab'),
        },
        {
            type: 'a2',
            title: t('G_item2_tab'),
        },
        {
            type: 'a3',
            title: t('G_item3_tab'),
        },
        // au 多一个
        ...(locale === 'au'
            ? [
                  {
                      type: 'a4',
                      title: t('G_item4_tab'),
                  },
              ]
            : []),
    ];

    const tabObj: any = {
        a1: {
            pc: img1.pc,
            h5: img1.h5,
            title: t.rich('G_item1_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t.rich('G_item1_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
        a2: {
            pc: img2.pc,
            h5: img2.h5,
            title: t.rich('G_item2_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t.rich('G_item2_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
        a3: {
            pc: img3.pc,
            h5: img3.h5,
            title: (
                <EfIcon
                    className="title-icon-a"
                    pc={
                        locale === 'au'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1736921253575/X-guard.png'
                            : 'https://websiteoss.ecoflow.com/upload/image/1722326378837/X-core.png'
                    }
                />
            ), //t('G_item3_title'),
            desc: t.rich('G_item3_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
        a4: {
            pc: img4?.pc,
            h5: img4?.h5,
            title: t.rich('G_item4_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t.rich('G_item4_desc', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
        },
    };
    // 选中的tab
    const [activeType, setActiveType] = useState('a1');
    const [activeItem, setActiveItem] = useState(tabObj[activeType] || tabObj['a1']);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
        setActiveItem(tabObj[item.type] || tabObj['a1']);
    };
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} theme={locale === 'jp' ? 'white' : 'black'} label={t('G_label')} title={t('G_title')} />
            <div className={`box ${theme}`}>
                <div className="box-img">
                    <EfImg pc={activeItem.pc} h5={activeItem?.h5 || activeItem.pc} />
                </div>
                <div className="box-msg">
                    <div className="box-title">{activeItem.title}</div>
                    <div className="box-desc">{activeItem.desc}</div>
                </div>
            </div>
            <EfTab theme={locale === 'jp' ? theme : 'white'} list_name={t('G_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} />
        </div>
    );
}
